export default {
  buttons: { done: 'Done' },
  title: 'Location',
};
